import React from 'react';
import { LeadForm } from '../components/site/LeadForm';
import { demoFields } from '../components/site/leadFormConfigs';
import { PageRenderer } from '../components/site/PageRenderer';
import { Seo } from '../components/site/Seo';
import { useSiteContent } from '../context/SiteContentContext';

export function RequestDemoPage() {
  const { siteContent } = useSiteContent();
  const page = siteContent.pages.requestDemo;

  return (
    <>
      <Seo page={page} />
      <PageRenderer page={page} />
      <section className='content-section cta-form-section'>
        <div className='contact-layout'>
          <LeadForm
            formName='demoRequest'
            title='Demo request'
            intro='Tell us about your part or process and we&#x2019;ll tailor the conversation.'
            fields={demoFields}
            submitLabel='Request demo'
          />
        </div>
      </section>
    </>
  );
}
